module.exports = __webpack_public_path__ + "valhalaBackground.png";